// Token management utilities
import { msUntilExpiry } from './jwt';
import Cookies from 'js-cookie';

export class TokenManager {
  // Check if access token is actually expired
  static isTokenActuallyExpired(token) {
    if (!token) return true;

    try {
      const timeUntilExpiry = msUntilExpiry(token);
      return timeUntilExpiry <= 0;
    } catch {
      return true; // Treat parsing errors as expired
    }
  }

  // Legacy method - now uses actual expiry for logout logic
  static isTokenExpired(token) {
    return this.isTokenActuallyExpired(token);
  }

  // Get remaining time until token expires (in minutes)
  static getTokenExpiryMinutes(token) {
    if (!token) return 0;

    try {
      const timeUntilExpiry = msUntilExpiry(token);
      return Math.floor(timeUntilExpiry / (60 * 1000));
    } catch {
      return 0;
    }
  }

  // Get access token from localStorage
  static getAccessToken() {
    return localStorage.getItem('token');
  }

  // Set access token in localStorage
  static setAccessToken(token) {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }

  // Clear all auth data
  static clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userUsername');
  }

  // Get user data from localStorage
  static getUserData() {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('userId');
    const email = localStorage.getItem('userEmail');
    const role = localStorage.getItem('userRole');
    const username = localStorage.getItem('userUsername');

    return token
      ? {
          token,
          id: id || undefined,
          email: email || undefined,
          role: role || undefined,
          username: username || undefined
        }
      : null;
  }

  // Set user data in localStorage
  static setUserData(user) {
    if (user.id) localStorage.setItem('userId', user.id);
    if (user.email) localStorage.setItem('userEmail', user.email);
    if (user.role) localStorage.setItem('userRole', user.role);
    if (user.username) localStorage.setItem('userUsername', user.username);
  }

  // Check if user is authenticated (has token - don't validate expiration)
  static isAuthenticated() {
    const token = this.getAccessToken();
    return !!token; // Just check if token exists, let backend validate expiration
  }

  // Get refresh token from HttpOnly cookie using js-cookie
  static getRefreshTokenFromCookie() {
    const refreshToken = Cookies.get('refreshToken');
    return refreshToken || null;
  }
}

export default TokenManager;
